const _ = "styles-module__booking_summary___-YidA", t = "styles-module__booking_legal_notice___I3NQJ", o = "styles-module__booking_summary_content___I-F0O", e = "styles-module__total_summary___eXEHN", s = "styles-module__gift_card_summary___GSM6C", a = "styles-module__total___K5lfM", m = "styles-module__insurance_summary___d0C5k", d = "styles-module__cart_item___pJfkB", c = "styles-module__price_item___35bO-", i = "styles-module__accommodation_card___XhcEZ", l = "styles-module__accommodation_header___uBwj-", n = "styles-module__accommodation_title___C59Z9", r = "styles-module__accommodation_title_number___XAdEs", u = "styles-module__accommodation_pricing_details___TyVCf", y = "styles-module__accommodation_type___YMlf1", g = "styles-module__rate_type_tags___9Sls4", f = "styles-module__tag___ZfXUf", b = "styles-module__modifiable___hvls9", p = "styles-module__non_refundable___NrxvO", h = "styles-module__accommodation_details___KtYU1", k = "styles-module__accommodation_totals___PbKhZ", v = "styles-module__divider___rFsim", w = "styles-module__price_item_total___LObyv", O = "styles-module__gift_card_container___AvH87", Z = "styles-module__gift_card_header___T-dTO", C = "styles-module__gift_card_input___4WtOr", X = "styles-module__gift_card_label___v6ueg", Y = "styles-module__gift_card_form___nL7gt", F = "styles-module__payment_methods___S3XuS", H = "styles-module__payment_methods_title___Guvrk", I = "styles-module__stay_info_card___xZd-u", J = "styles-module__stay_header___vo4YB", N = "styles-module__stay_details___HkvJ4", S = "styles-module__stay_detail_row___NFudk", T = "styles-module__date_details_container___FgYgb", x = "styles-module__date_details___1iIOm", A = "styles-module__date_check_in___wRvC8", B = "styles-module__time___qjh3p", E = "styles-module__date___8o9zP", K = "styles-module__instructions___yHa2u", L = "styles-module__guests_row___Zt40L", M = "styles-module__accommodation_divider___J-WP5", P = "styles-module__accommodation_subtitle___TIUuO", U = {
  booking_summary: _,
  booking_legal_notice: t,
  booking_summary_content: o,
  total_summary: e,
  gift_card_summary: s,
  total: a,
  insurance_summary: m,
  cart_item: d,
  price_item: c,
  accommodation_card: i,
  accommodation_header: l,
  accommodation_title: n,
  accommodation_title_number: r,
  accommodation_pricing_details: u,
  accommodation_type: y,
  rate_type_tags: g,
  tag: f,
  modifiable: b,
  non_refundable: p,
  accommodation_details: h,
  accommodation_totals: k,
  divider: v,
  price_item_total: w,
  gift_card_container: O,
  gift_card_header: Z,
  gift_card_input: C,
  gift_card_label: X,
  gift_card_form: Y,
  payment_methods: F,
  payment_methods_title: H,
  stay_info_card: I,
  stay_header: J,
  stay_details: N,
  stay_detail_row: S,
  date_details_container: T,
  date_details: x,
  date_check_in: A,
  time: B,
  date: E,
  instructions: K,
  guests_row: L,
  accommodation_divider: M,
  accommodation_subtitle: P
};
export {
  i as accommodation_card,
  h as accommodation_details,
  M as accommodation_divider,
  l as accommodation_header,
  u as accommodation_pricing_details,
  P as accommodation_subtitle,
  n as accommodation_title,
  r as accommodation_title_number,
  k as accommodation_totals,
  y as accommodation_type,
  t as booking_legal_notice,
  _ as booking_summary,
  o as booking_summary_content,
  d as cart_item,
  E as date,
  A as date_check_in,
  x as date_details,
  T as date_details_container,
  U as default,
  v as divider,
  O as gift_card_container,
  Y as gift_card_form,
  Z as gift_card_header,
  C as gift_card_input,
  X as gift_card_label,
  s as gift_card_summary,
  L as guests_row,
  K as instructions,
  m as insurance_summary,
  b as modifiable,
  p as non_refundable,
  F as payment_methods,
  H as payment_methods_title,
  c as price_item,
  w as price_item_total,
  g as rate_type_tags,
  S as stay_detail_row,
  N as stay_details,
  J as stay_header,
  I as stay_info_card,
  f as tag,
  B as time,
  a as total,
  e as total_summary
};
